(function () {
  function initRevealAnimations() {
    if (!('IntersectionObserver' in window)) return;
    var sections = document.querySelectorAll('#MainContent .shopify-section');
    if (!sections.length) return;

    var targets = [];
    sections.forEach(function (el, i) {
      if (i === 0) return;
      el.classList.add('bv-reveal');
      targets.push(el);
    });
    if (!targets.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('bv-reveal--visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRevealAnimations);
  } else {
    initRevealAnimations();
  }

  // Enlaces tipo #bv-scrollto-<section-key> hacen scroll suave a esa seccion.
  // Necesario porque Shopify renderiza el id real como
  // "shopify-section-template--<numero>__<section-key>", no como
  // "shopify-section-<section-key>", asi que un ancla literal nunca coincide.
  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href^="#bv-scrollto-"]');
    if (!link) return;
    var key = link.getAttribute('href').slice('#bv-scrollto-'.length);
    if (!key) return;
    var target =
      document.getElementById('shopify-section-' + key) ||
      document.querySelector('[id$="__' + key + '"]');
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
